export default function Avatar({ name, size = 32 }) {
  const colors = ["#0d9488", "#2563eb", "#7c3aed", "#ea580c", "#0891b2", "#dc2626", "#059669", "#d97706"];
  const ini = name?.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase() || "?";
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: colors[name?.charCodeAt(0) % colors.length],
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#fff", fontSize: size * 0.36, fontWeight: 700, flexShrink: 0,
    }}>
      {ini}
    </div>
  );
}
